var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8681 16.3001C13.1697 14.141 11.8188 12.8036 10.0287 11.2583C11.7804 9.85789 13.9573 9.09661 16.2 9.1001V1.9001H17.1072C17.6004 1.9001 18 2.3006 18 2.7938V17.2064C17.9984 17.4428 17.9038 17.669 17.7367 17.8362C17.5697 18.0034 17.3436 18.0982 17.1072 18.1001H0.8928C0.655932 18.0999 0.428847 18.0056 0.26144 17.838C0.0940338 17.6704 -1.2011e-07 17.4433 0 17.2064V2.7938C0.00164704 2.55744 0.0962102 2.33121 0.263262 2.16399C0.430313 1.99677 0.656442 1.90198 0.8928 1.9001H3.6V0.100098H5.4V3.7001H1.8V10.0001C6.498 10.0001 10.4958 12.2159 11.9817 16.3001H13.8681ZM14.4 0.100098V3.7001H7.2V1.9001H12.6V0.100098H14.4ZM13.05 8.2001C12.692 8.2001 12.3486 8.05787 12.0954 7.80469C11.8422 7.55152 11.7 7.20814 11.7 6.8501C11.7 6.49206 11.8422 6.14868 12.0954 5.8955C12.3486 5.64233 12.692 5.5001 13.05 5.5001C13.408 5.5001 13.7514 5.64233 14.0046 5.8955C14.2578 6.14868 14.4 6.49206 14.4 6.8501C14.4 7.20814 14.2578 7.55152 14.0046 7.80469C13.7514 8.05787 13.408 8.2001 13.05 8.2001Z",
    fill: "#525866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryFill);
export default __webpack_public_path__ + "static/media/gallery-fill.1d723b4fbda41866309f60ca76e44425.svg";
export { ForwardRef as ReactComponent };